import React from 'react';
import { Paper, Typography, Box, Button, CircularProgress } from '@mui/material';

import { FilterDropdown } from './components';
import useFilters from './useFilters';
import RenderIf from '../../renderIf/RenderIf';

import useStyles from './styles';

const FilterControls = ({ filters, selectedFilters: previouslySelectedFilters, disabled, isFetching, handleFilterChange }) => {
    const classes = useStyles();

    const { selectedFilters, updateSelections, clearAllSelections } = useFilters(filters, previouslySelectedFilters, handleFilterChange);

    return (
        <Paper className={classes.dashboardPaper}>
            <Box
                sx={{
                    display: 'flex',
                    gap: '1rem',
                    marginBottom: (theme) => theme.spacing(2),
                }}
            >
                <Typography
                    variant="h5"
                    sx={{ fontSize: '18px', fontWeight: 600 }}
                >
                    Filters
                </Typography>
                <Button
                    className="button-link"
                    disabled={disabled || isFetching}
                    onClick={clearAllSelections}
                    sx={{ fontSize: '10px', fontWeight: 600 }}
                >
                    clear all filters
                </Button>
            </Box>

            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                }}
            >
                <Box>
                    {Object.entries(filters)?.map?.(([key, filterObj]) => {
                        return (
                            <FilterDropdown
                                key={`filter-${key}`}
                                filterKey={key}
                                label={filterObj.label}
                                filter={filterObj.filters}
                                value={selectedFilters?.[key] ? selectedFilters[key] : []}
                                handleUpdate={updateSelections}
                                disabled={disabled || isFetching}
                            />
                        );
                    })}

                    <RenderIf isTrue={isFetching}>
                        <CircularProgress sx={{ marginLeft: '1rem' }} />
                    </RenderIf>
                </Box>
            </Box>
        </Paper>
    );
};

export default FilterControls;
